import TopFeaturedProducts from './TopFeaturedProducts'

export default TopFeaturedProducts
